import { z } from 'zod';

import { commonErrors } from '@utils/error';
import { doesNotExist } from '@utils/general';
import { checkbox, commonParams, optionalString, superRefineHelper } from '@utils/validation';
import { IMemberEstrogenGoalsPageContent } from '@ui/routes/MemberEstrogen/MemberEstrogenGoalsStep/MemberEstrogenGoalsStep.component';

export const testContent: IMemberEstrogenGoalsPageContent = {
	pageHeader: 'What changes are you most excited for?',
	pageInfo: `Everyone's journey looks different. Knowing the changes you are excited about helps us prescribe medication(s) that best fits you. Select all that apply.
	You can discuss your unique goals, and any changes you don't want, with your clinician during your virtual appointment.`,

	hrtGoalsEmotionalBenefits: 'Emotional benefits',
	hrtGoalsGenderEuphoria: 'Gender euphoria',
	hrtGoalsSoftenFace: 'Soften face structure',
	hrtGoalsImproveLibido: 'Improve libido & sexual satisfaction',
	hrtGoalsIncreaseErectileFunction: 'Increase erectile function',
	hrtGoalsDecreaseErectileFunction: 'Decrease erectile function',
	hrtGoalsRedistributeFat: 'Body fat distribution',
	hrtGoalsReduceSweating: 'Reduce sweating',
	hrtGoalsDevelopBreasts: 'Develop breast tissue',
	hrtGoalsBodyHair: 'Reduce body hair',
	hrtGoalsFacialHair: 'Reduce facial hair',
	hrtGoalsOther: 'Other',
};

export const schema = z
	.object({
		hrtGoalsEmotionalBenefits: checkbox,
		hrtGoalsGenderEuphoria: checkbox,
		hrtGoalsSoftenFace: checkbox,
		hrtGoalsImproveLibido: checkbox,
		hrtGoalsIncreaseErectileFunction: checkbox,
		hrtGoalsDecreaseErectileFunction: checkbox,
		hrtGoalsRedistributeFat: checkbox,
		hrtGoalsReduceSweating: checkbox,
		hrtGoalsDevelopBreasts: checkbox,
		hrtGoalsBodyHair: checkbox,
		hrtGoalsFacialHair: checkbox,
		hrtGoalsOther: checkbox,
		hrtGoalsOtherText: optionalString,
	})
	.superRefine((data, ctx) => {
		const params = commonParams(data, ctx);

		if (data.hrtGoalsOther) {
			superRefineHelper({
				...params,
				dataPath: 'hrtGoalsOtherText',
				negativeCondition: doesNotExist,
				message: commonErrors.inputRequired,
			});
		}
	});
